module.exports = __webpack_public_path__ + "static/media/012.1a74e563.jpg";